export { Substitutions as default } from "./substitutions";
